{
    "a11y": {
        "closeDialog": "Dialog schließen",
        "closeImage": "Bildansicht schließen",
        "closePopup": "Map-Punkt schließen",
        "closeSearch": "Suche schließen",
        "closeToc": "Inhaltsverzeichnis schließen",
        "cookieSettings": "Datenschutzeinstellungen öffnen",
        "downloadSection": "„{section}“ herunterladen",
        "enlargeImage": "Bild vergrößern",
        "imageViewer": "Bildansicht",
        "languageMenu": "Sprache wählen",
        "mainMenu": "Hauptmenü",
        "mapInstructions": "Mit den Pfeiltasten zwischen den Map-Punkten wechseln, mit Eingabe- oder Leertaste einen Punkt öffnen. Plus und Minus zoomen, 0 zeigt die ganze Karte.",
        "mapRoleDescription": "Interaktive Karte",
        "menu": "Menü",
        "openSearch": "Suche öffnen",
        "openToc": "Inhaltsverzeichnis öffnen",
        "pointsList": "Map-Punkte",
        "share": "Diese Karte teilen",
        "shareVia": "Teilen über {network}",
        "skipToPoints": "Zu den Map-Punkten springen",
        "unnamedPoint": "Map-Punkt ohne Titel",
        "videoPlayer": "Videoplayer",
        "zoomIn": "Vergrößern",
        "zoomLevel": "Zoomstufe {level}",
        "zoomLevelAnnounce": "Zoomstufe {level}, {count} Map-Punkte sichtbar",
        "zoomOut": "Verkleinern",
        "zoomToFit": "Ganze Karte anzeigen"
    },
    "editorial": {
        "close": "Editorial schließen",
        "defaultTitle": "Editorial und Team",
        "team": "Team"
    },
    "gallery": {
        "next": "Nächstes Bild",
        "position": "Bild {index} von {total}",
        "previous": "Vorheriges Bild"
    },
    "back": "zurück",
    "blockedMsg": "Externe Inhalte sind durch deine Datenschutzeinstellungen blockiert.",
    "changePrivacySettings": "Datenschutzeinstellungen verwalten",
    "connections": "Verbunden mit:",
    "contentLastUpdate": "Letzte Aktualisierung:",
    "acceptAll": "Alle akzeptieren",
    "acceptEssentialOnly": "Nur essentielle Cookies akzeptieren",
    "imprint": "Impressum",
    "privacyPolicy": "Datenschutzerklärung",
    "saveSettings": "Einstellungen speichern",
    "title": "Datenschutzeinstellungen",
    "failed": "Inhalt konnte nicht geladen werden.",
    "loading": "Lade Inhalt …",
    "socialMedia": "Diesen Artikel teilen:",
    "resetSearch": "Suche zurücksetzen",
    "search": "Suchen",
    "zoomLevels": "Zoomstufen",
    "previewNotice": "Dies ist eine Vorschau der letzten Änderungen, nicht die Live-Ansicht der Map!"
}
